import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { MainLayoutComponent } from './components/layout/main-layout/main-layout.component';
import { ProductListComponent } from './components/product/product-list/product-list.component';
import { QuoteListComponent } from './components/quote/quote-list/quote-list.component';
import { SupplierListComponent } from './components/supplier/supplier-list/supplier-list.component';
import { SupplierViewDetailsComponent } from './components/supplier/supplier-view-details/supplier-view-details.component';
import { TeamListComponent } from './components/team/team-list/team-list.component';
import { ProductManagementComponent } from './components/admin/product-management/product-management.component';
import { CategoryManagementComponent } from './components/admin/category-management/category-management.component';
import { VendorManagementComponent } from './components/admin/vendor-management/vendor-management.component';
import { AddProductComponent } from './components/admin/add-product/add-product.component';
import { ViewProductDetailsComponent } from './components/product/view-product-details/view-product-details.component';
import { QuoteCompareComponent } from './components/product/quote-compare/quote-compare.component';
import { LeadsComponent } from './components/supplier/leads/leads.component';
import { ViewLeadDetailsComponent } from './components/supplier/view-lead-details/view-lead-details.component';
import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [loginGuard] },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'product', component: ProductListComponent },
      { path: 'product/category', component: CategoryManagementComponent },
      { path: 'product/manage', component: ProductManagementComponent },
      { path: 'product/add', component: AddProductComponent },
      { path: 'product/view/:id', component: ViewProductDetailsComponent },
      { path: 'products/compare-quotes', component: QuoteCompareComponent },
      { path: 'quote', component: QuoteListComponent },
      { path: 'quote/view/:id', component: ViewLeadDetailsComponent },
      { path: 'leads', component: LeadsComponent },
      { path: 'leads/view/:id', component: ViewLeadDetailsComponent },
      { path: 'supplier', component: SupplierListComponent },
      { path: 'supplier/view/:id', component: SupplierViewDetailsComponent },
      { path: 'supplier/manage', component: VendorManagementComponent },
      { path: 'team', component: TeamListComponent },
      { path: '**', redirectTo: '/product', pathMatch: 'full' }
    ]
  }
];






